import product005 from "./product-005.jpg";
import product008 from "./product-008.jpg";
import product011 from "./product-011.jpg";
import product013 from "./product-013.jpg";
import product015 from "./product-015.jpg";
import product016 from "./product-016.jpg";

/**
 * 产品图本地资源（经 Vite 处理后的最终 URL，供 img src 与 i18n 数据使用）
 */
export const PRODUCT_IMG = {
  product005,
  product008,
  product011,
  product013,
  product015,
  product016,
} as const;
